"use client";

import React from "react";
import { Download, Volume2, Headphones } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Actionbar() {
  const shouldReduceMotion = useReducedMotion();
  const actionItems = [{
    title: "DESCARGAR PDF",
    icon: Download,
    href: "#",
    ariaLabel: "Descargar Declaración de Verdades Fundamentales en PDF"
  }, {
    title: "AUDIO (DECLARACIONES Y ESCRITURAS)",
    icon: Volume2,
    href: "#",
    ariaLabel: "Escuchar audio de declaraciones y escrituras"
  }, {
    title: "AUDIO (DECLARACIONES)",
    icon: Headphones,
    href: "#",
    ariaLabel: "Escuchar audio de declaraciones"
  }];
  return <section id="actionpillbar" data-nav="light" className="w-full bg-background py-6 sm:py-8">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <motion.div initial={shouldReduceMotion ? {} : {
        opacity: 0,
        y: 12
      }} animate={shouldReduceMotion ? {} : {
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: "easeOut"
      }} className="bg-foreground text-background shadow-md rounded-2xl md:rounded-full px-4 py-3 sm:px-8 sm:py-4">
          <nav aria-label="Recursos y descargas" className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-0">
            {actionItems.map((item, i) => {
            const Icon = item.icon;
            return <React.Fragment key={item.title}>
                  <div data-index={i} className="w-full md:w-auto flex items-center justify-center">
                    <Link to={item.href} aria-label={item.ariaLabel} className="group flex items-center justify-center gap-2.5 px-4 py-2 text-xs sm:text-sm font-semibold tracking-wider text-background/90 hover:text-background transition-colors duration-200 text-center uppercase">
                      <Icon className="size-4 shrink-0 transition-transform duration-200 group-hover:scale-110 opacity-80 group-hover:opacity-100" />
                      <span>{item.title}</span>
                    </Link>
                  </div>

                  {i < actionItems.length - 1 && <div className="hidden md:flex items-center h-5 px-3">
                      <Separator orientation="vertical" className="bg-background/25 h-4 w-px" />
                    </div>}

                  {i < actionItems.length - 1 && <div className="w-full md:hidden">
                      <Separator orientation="horizontal" className="bg-background/15 w-full" />
                    </div>}
                </React.Fragment>;
          })}
          </nav>
        </motion.div>
      </div>
    </section>;
}